import { useCallback, useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { localCustomNavAtom, logInfoAtom, showLoginAtom } from "@/store";
import { updatePreference } from "@/utils/net.js";

export type Navs = {
  title: string;
  location: string;
  permission: string;
  hoverText?: string;
  key?: string;
}[];

export const useCustomNav = () => {
  const logInfo = useRecoilValue(logInfoAtom);
  const setShowLogin = useSetRecoilState(showLoginAtom);
  const [localCustomNav, setlocalCustomNav] = useRecoilState<
    {
      title: string;
      location: string;
      permission: string;
      hoverText?: string;
      key?: string;
    }[]
  >(localCustomNavAtom);

  const [fetchRemote, setRemote] = useState(0);

  const setCustomNav = useCallback((navs: Navs | ((prev: Navs) => Navs)) => {
    if (!logInfo) {
      setShowLogin(true);
      return;
  }
    setRemote((prev) => {
      return prev + 1;
    });
    setlocalCustomNav(navs);
  }, []);

  useEffect(() => {
    if (fetchRemote) {
      updatePreference({
        preference: {
          customNav: JSON.stringify(localCustomNav.map((nav) => nav.key)),
        },
      });
    }
  }, [fetchRemote]);

  return {
    customNav: localCustomNav,
    setCustomNav,
  };
};
